import React from 'react';

import { getWindow } from '../globals';

export const fixImageSrc = (src, size, cloudinaryOptions = {}) =>
  src.replace(
    'http://s3-eu-west-2.amazonaws.com/styrelsen/',
    `https://res.cloudinary.com/styrelsen-nu/image/fetch/${
      cloudinaryOptions.extra ? cloudinaryOptions.extra + ',' : ''
    }f_auto,w_${Math.round(size.width / 100) * 100}${
      size.height
        ? `,h_${Math.round(size.height / 100) * 100}${
            cloudinaryOptions.g_auto ? ',g_auto' : ''
          }`
        : ''
    }${
      size.cover ? ',c_fill' : ''
    },fl_progressive,fl_immutable_cache,fl_lossy/dpr_${(getWindow() &&
      getWindow().devicePixelRatio) ||
      '1.0'}/${
      cloudinaryOptions.overlay
        ? `l_fetch:${btoa(cloudinaryOptions.overlay.url)},${
            cloudinaryOptions.overlay.extra
          }/`
        : ''
    }https://www.styrelsen.nu/`
  );

export const Image = ({
  src,
  width,
  height,
  alt,
  cover,
  className,
  cloudinaryOptions,
  ...restProps
}) => (
  <img
    css={`
      display: block;
      max-width: 100%;
      height: auto;
      ${className};
    `}
    alt={alt}
    src={fixImageSrc(src, { width, height, cover }, cloudinaryOptions)}
    {...restProps}
  />
);



// WEBPACK FOOTER //
// ./app/components/Image.js